import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.6); opacity: 0.3; }
  100% { transform: scale(1); opacity: 0.8; }
`;

/**
 * A small pulsing dot that draws attention to an unvisited sidebar item.
 * Disappears once the user visits the page.
 */
export default function FeatureBeacon() {
  return (
    <Box
      w="6px"
      h="6px"
      borderRadius="full"
      bg="brand.500"
      flexShrink={0}
      css={{ animation: `${pulse} 2s ease-in-out infinite` }}
    />
  );
}
